var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1687_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 43.3333C16.6666 41.5652 17.369 39.8695 18.6192 38.6192C19.8695 37.369 21.5652 36.6666 23.3333 36.6666H56.6666C58.4347 36.6666 60.1304 37.369 61.3807 38.6192C62.6309 39.8695 63.3333 41.5652 63.3333 43.3333V63.3333C63.3333 65.1014 62.6309 66.7971 61.3807 68.0473C60.1304 69.2976 58.4347 70 56.6666 70H23.3333C21.5652 70 19.8695 69.2976 18.6192 68.0473C17.369 66.7971 16.6666 65.1014 16.6666 63.3333V43.3333Z",
    stroke: "#0F2E59",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 53.3333C36.6666 54.2174 37.0178 55.0652 37.6429 55.6904C38.2681 56.3155 39.1159 56.6667 40 56.6667C40.884 56.6667 41.7319 56.3155 42.357 55.6904C42.9821 55.0652 43.3333 54.2174 43.3333 53.3333C43.3333 52.4493 42.9821 51.6014 42.357 50.9763C41.7319 50.3512 40.884 50 40 50C39.1159 50 38.2681 50.3512 37.6429 50.9763C37.0178 51.6014 36.6666 52.4493 36.6666 53.3333Z",
    stroke: "#0F2E59",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 36.6667V23.3333C26.6666 19.7971 28.0714 16.4057 30.5719 13.9052C33.0724 11.4048 36.4637 10 40 10C43.5362 10 46.9276 11.4048 49.428 13.9052C51.9285 16.4057 53.3333 19.7971 53.3333 23.3333V36.6667",
    stroke: "#0F2E59",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1687_3312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c7dc779e3215b0bdd9977c0123930bb1.svg";
export { ForwardRef as ReactComponent };